import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const container = document.getElementById("root")!;
const root = createRoot(container);

const renderApp = () => {
  root.render(<App />);
  // Mark app as mounted to hide critical CSS loader
  document.documentElement.classList.add("app-mounted");
};

// Ensure DOM is ready before rendering to prevent layout thrashing
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", renderApp);
} else {
  renderApp();
}
